<template>
	<div id="circuitBreakerAging" class="column-center" style="justify-content: space-between">
		<div class="top">
			<p>触头磨损情况</p>
			<div class="status row-center" style="justify-content: flex-end">
				<div class="diagram">
					<Percentage :number="num"></Percentage>
				</div>

				<div class="status-text row-center" style="justify-content: flex-start" v-if="num<60">
					<img src="../../assets/img/success.png" alt="">
					<p>断路器触头状况良好，可继续使用。</p>
				</div>
				<div class="status-text row-center status-red" style="justify-content: flex-start" v-else-if="num>=60||num=='--'">
					<img src="../../assets/img/error.png" alt="">
					<!-- <p>断路器触头磨损严重，请及时更换断路器触头!</p> -->
					<p>未知</p>
				
				</div>
				<!-- <div class="status-text row-center status-yellow" style="justify-content: flex-start" v-else-if="num>=60">
					<img src="../../assets/img/error-yellow.png" alt="">
					<p>断路器触头磨损严重，请及时更换断路器触头!</p>
				</div> -->
			</div>

			<!--<div class="diagram-bottom row-center" style="justify-content: space-between">-->
			<!--	<div class="canvas">-->
			<!--		<div class="title">-->
			<!--			<span>分合闸电压监测</span>-->
			<!--			<span class="realTimeData">123V</span>-->
			<!--		</div>-->
			<!--		<div class="charts">-->
			<!--			<Curve></Curve>-->
			<!--		</div>-->
			<!--	</div>-->
			<!--	<div class="canvas">-->
			<!--		<div class="title">-->
			<!--			<span>分合闸电压监测</span>-->
			<!--			<span class="realTimeData">123V</span>-->
			<!--		</div>-->
			<!--		<div class="charts">-->
			<!--			<Curve></Curve>-->
			<!--		</div>-->
			<!--	</div>-->
			<!--</div>-->
		</div>
		<div class="bottom">
			<div class="title">负载实时电流</div>
			<div class="diagram-2 " style="justify-content: space-between">
				<!-- <div class="diagram-content">
					<div class="tit">
						<span>断路器电流监测</span>
						<span class="realTimeData" v-if="max=='--'">{{max}}</span>
						<span class="realTimeData" v-else>{{max}}A</span>
					</div>
					<div class="line"></div>
				</div> -->
				<div class="diagram-content">
					<div class="tit">
						<span>断路器额定电流:</span>
						<span class="realTimeData">{{currentLoop.breakerRatedCurrent}}A</span>
					</div>
					<div class="line">
						<div class="land">
							<span>实时电流</span>
							<span class="realTimeData" v-if="maxdata.max=='--'">{{maxdata.max}}</span>
							<span class="realTimeData" v-else>{{maxdata.max}}A</span>
						</div>
						<span :style="{width:maxdata.widthval+'%'}" :class="maxdata.widthval>40?'red':''"  class="role"></span>
					</div>
				</div>

				<div class="abs"><img src="../../assets/img/tips.png">安全电流警戒线</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Percentage from "../../components/home/Percentage";
	import Curve from "../../chart/Curve";

	export default {
		name: "CircuitBreakerAging",
		components: {
			Percentage,
			Curve
		},
		props:{
			currentLoop:Object,
			data:String
		},
		data(){
			return{
				num:0,
				list:["Ia","Ib","Ic"],
				max:"",
				widthval:0
			}
		},
		watch:{
			currentLoop(){
				this.num = this.data
			},
		},
		 computed: {
            mqttval() {
                return this.getMqttVal(this.$store.getters.mqttVal)
            },
			 maxdata(){
				 let arr = []
				this.list.forEach(element => {
					arr.push(this.mqttval(element))
				});
				arr.sort(function (a, b) {return a-b;});
				if(arr[arr.length - 1]!="--"){
					this.max = Number(arr[arr.length - 1]).toFixed(2);
					this.widthval = (Number(this.max)/Number(this.currentLoop.breakerRatedCurrent))*100
				}else{
					this.max = '--'
					this.widthval = 0
				}
				return {max:this.max,widthval:this.widthval}
			 }
		 },
		 mounted(){
			this.num = this.data
		 },
		 methods: {
			getMqttVal(f) {
                return (k, m) => {
                    if (this.currentLoop && k) {
                        k = this.currentLoop.subLoopUrl + "/" + k;
                        let mqttVal = f(k); 
                        if (m) {
                            mqttVal *= m;
                        }
						// if(k=='Contact_wear'){
						// 	mqttVal = mqttVal;
						// }else{
						// 	mqttVal = floatFormat(mqttVal, 2);
						// }
                        

                        if (typeof mqttVal === "object") {
                            return mqttVal;
                        }
                        return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
                    } else {
                        return "--";
                    }
                };
            },
		 }
	}
</script>

<style scoped lang="less">
	.land{
		position: relative;
		z-index: 225;
		color: #333;
		font-size: 18rem;
		line-height: 80rem;
		margin-left: 20rem;
		.realTimeData{
			font-weight: bold;
			font-size: 22rem;
			margin-left: 10rem;
		}
	}
	.bottom {
		/*padding: 23rem 51rem 48rem 24rem;*/
		background-color: #fff;
		padding-top: 24rem;
		.h(280);
		width: 100%;

		.title {

			font-size: 18rem;
			font-weight: bold;
			color: #333333;
		}

		.diagram-2 {
			width:100%;
			// .h(131);
			margin-top: 40rem;
			position: relative;

			.abs {
				position: absolute;
				bottom: 0;
				left: 40%;
				font-size: 16rem;
				font-weight: 400;
				color: #FF9D4D;
				height: 100px;
				// border-left: 2px dashed #FF9D4D;
				padding-left: 7rem;
				// line-height: 76px;
				overflow: hidden;
				&::before{
					content: "";
					border-left: 2px dashed #FF9D4D;
					height: 100%;
					display: inline-block;
					position: absolute;
					top: 25px;
					left: 12px;
				}
				img{
					vertical-align: middle;
					width: 16px;
					margin-right: 5px;
				}
			}

			.diagram-content {
				width: 100%;
				position: relative;
				.line {
					width:100%;
					// .h(8);
					height: 80rem;
					border-radius: 8rem;
					background-color: #F0F3F6;
					// opacity: 0.3;
					margin-top: 12rem;
					position: relative;
					overflow: hidden;
					.role{
						position: absolute;
						top: 0;
						left: 0px;
						background: #b0e6ff;
						height: 100%;
						border-radius: 8rem;
					}
					.red{
						background: #FD4238;
					}
				}

				.tit {

					font-size: 18rem;
					font-weight: 400;
					color: #666666;
					margin-left: 10px;
					.realTimeData {
						// font-size: 24rem;
						// font-weight: bold;
						color: #333333;
						// margin-left: 15rem;
					}
				}
			}
		}
	}
	.diagram-bottom {
		margin-top: 75rem;

		.canvas {
			.w(584);
			.h(234);

			.charts {
				.w(581);
				.h(200);
				margin-top: 16rem;
			}

			.title {
				font-size: 18rem;
				font-weight: 400;
				color: #333333;

				.realTimeData {

					font-size: 24px;
					font-weight: bold;
					margin-left: 18rem;
				}
			}
		}
	}
	#circuitBreakerAging {

		width: 100%;
		.h(910);


		.diagram {
			width: 259rem;
			height: 259rem;
		}

		.top {
			/*padding: 23rem;*/
			padding-right: 0;
			width: 100%;
			.h(630);
			padding-top: 55rem;
			background: #FFFFFF;
			border-bottom: 1px solid rgba(0, 0, 0, 0.06);

			> p {
				font-size: 18rem;
				font-weight: bold;
				color: #333333;
			}
		}


		.status {
			margin-top: 85rem;
		}

		.status-text {
			.w(744);
			border-bottom: 1px solid rgba(0, 43, 102, 0.15);
			padding-bottom: 19rem;
			margin-left: 128rem;

			p {

				font-size: 24px;
				font-weight: 400;
				color: #68D86A;
				margin-left: 16rem;
			}
		}
		.status-red {
			p{
				color: #FD4238;
			}
		}
		
		.status-yellow {
			p{
				color: #F5AA00;
			}
		}
	}
</style>